import { Card, Col, Row } from "antd";
import React from "react";

import { RiAddLine } from "react-icons/ri";

import "./ScreeningReports.css";

function ScreeningReports({ data }) {
  return (
    <div className="screening-reports">
      <Card title="Screening Reports">
        <Card
          title={data?.cardTitle}
          extra={
            <button className="icon-text-btn">
              <RiAddLine size={18} />
              <span>Screen Now</span>
            </button>
          }
        >
          <Row>
            <Col span={24} className="col-container">
              <Row align="bottom">
                <Col span={6}>
                  <span>Screening Report</span>
                </Col>
                <Col span={6}>
                  <span>View Preliminary Results</span>
                </Col>
                <Col span={10}>
                  <h3>Date</h3>
                  <p>02/09/2021 at 01:59 PM</p>
                </Col>
                <Col span={2}>
                  <span className="onclick-text">Re-Screen</span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Card>
    </div>
  );
}

export default ScreeningReports;
